import React from 'react';
import PT from 'prop-types';
import { groupBy, map, find } from 'lodash';
import { ResponsivenessGrid } from '../toolkit';
import TranslatorManager from 'ts-translate-js';
import cIf from 'classnames';

const tr = TranslatorManager.boundTR;

export function PointOfSaleList({ pointOfSaleList, provinceList, integ }) {
    const posByProvince = groupBy(pointOfSaleList, 'Province');
    const allPosList = map(posByProvince, (value, key) => {
        const provinceName = find(provinceList, (o) => { return o.Abbreviation == key; });
        return <Province pointOfSaleList={value} provinceName={provinceName.NameFr} key={key} />;
    });
    return <div className={cIf([integ])}>
        <h2>{tr("Points de vente")}</h2>
        <br />
        {allPosList}
    </div>;
}
PointOfSaleList.propTypes = {
    pointOfSaleList: PT.array,
    provinceList: PT.array,
    integ: PT.string
};

export function Province(props) {
    const posByRegion = groupBy(props.pointOfSaleList, 'Region');
    const allPosList = map(posByRegion, (value, key) => {
        return <Region pointOfSaleList={value} regionName={key} key={key} />;
    });

    return (
        <div className="content-text">
            <h3>{props.provinceName}</h3>
            <hr />
            {allPosList}
            <hr />
        </div>
    );
}
Province.propTypes = {
    pointOfSaleList: PT.array,
    provinceName: PT.string
};

export function Region(props) {
    const allPosList = map(props.pointOfSaleList, (value) => { return <PointOfSaleInfo pointOfSale={value} key={value.ID} />; });
    return (
        <div>
            <h4>{props.regionName}</h4>
            <hr />
            <ResponsivenessGrid 
                items={allPosList}
                breakpointsConfigs={{ mobile: 767, tablet: 1250, small: 1800, large: 50000 }}
                nbrColumnsByBreakpointConfigs={{ mobile: 1, tablet: 2, small: 3, large: 4 }}
            />
        </div>
    );
}
Region.propTypes = {
    pointOfSaleList: PT.array,
    regionName: PT.string
};


export function PointOfSaleInfo(props) {
    return (
        <address>
            <b>{props.pointOfSale.Name}</b>
            <br />{props.pointOfSale.Address}
            <br />{props.pointOfSale.City}
            <br />{props.pointOfSale.PostalCode}
            <br />{tr(`Tél. :`)}{props.pointOfSale.Phone}
            <br />
        </address>
    );
}
PointOfSaleInfo.propTypes = {
    pointOfSale: PT.object
};
